import { render } from "./ImgLogo.vue?vue&type=template&id=6a5af7f5"
import script from "./ImgLogo.vue?vue&type=script&lang=js"
export * from "./ImgLogo.vue?vue&type=script&lang=js"

import "./ImgLogo.vue?vue&type=style&index=0&id=6a5af7f5&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__